import { Button, Dialog, DialogActions, DialogContent, DialogTitle, SxProps } from '@mui/material';
import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { setNextArea } from '../../../redux/user/sliceUserSettings';
import { IAppReduxStore } from '../../../redux/store';
import { bodyFont, headingFontBold, vars } from '../../../Theme';
import { getRedirectUrl } from '../../../util/ProjectUtils';

export default () => {
    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'projectView' });

    /** Get relevant values from Redux store. */
    const nextArea = useSelector((store: IAppReduxStore) => store.userSettings.nextArea);

    /** Allow component to change the URL. */
    const navigate = useNavigate();

    /** Get the replicaId, areaName, viewName and category from the react router. */
    const { replicaId } = useParams();

    /**
     * Closes the dialog.
     */
    const close = () => dispatch(setNextArea(null));

    /**
     * Takes the user to their selected new project area.
     */
    const handleChangeArea = () => {
        navigate(getRedirectUrl(replicaId, nextArea));

        close();
    };

    /** Dialog title area styles. */
    const titleSx: SxProps = {
        textAlign: 'center',
        img: { display: 'block', mx: 'auto', my: 2, width: 300 },
    };

    /** Dialog action area styles. */
    const actionsSx: SxProps = {
        flexDirection: 'column',
        button: {
            textTransform: 'none',
            ...headingFontBold,
            color: vars.font,
            width: 200,
            mb: 1,
            p: 1,
        },

        '.MuiButton-contained.MuiButton-colorPrimary': {
            color: vars.white,
        },
    };

    return (
        <Dialog onClose={close} open={!!nextArea} maxWidth='xs'>
            <DialogTitle sx={titleSx}>
                <img src={process.env.PUBLIC_URL + '/assets/error.png'} />
                {t('areaChangeWarningTitle')}
            </DialogTitle>

            <DialogContent sx={{ ...bodyFont, textAlign: 'center' }}>
                {t('areaChangeWarningMessage')}
            </DialogContent>

            <DialogActions sx={actionsSx} disableSpacing>
                <Button variant='contained' onClick={handleChangeArea}>
                    {t('continue')}
                </Button>
                <Button onClick={close}>{t('cancel')}</Button>
            </DialogActions>
        </Dialog>
    );
};
